"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoctorAttendingsHttpService = void 0;
const types_1 = require("../../types");
const activate_doctor_attending_1 = require("../../types/doctor-attendings/activate-doctor-attending");
const create_doctor_attending_1 = require("../../types/doctor-attendings/create-doctor-attending");
const create_doctor_attending_by_doctor_1 = require("../../types/doctor-attendings/create-doctor-attending-by-doctor");
const delete_doctor_attending_1 = require("../../types/doctor-attendings/delete-doctor-attending");
const get_doctor_attending_list_1 = require("../../types/doctor-attendings/get-doctor-attending-list");
const get_doctor_attending_offices_1 = require("../../types/doctor-attendings/get-doctor-attending-offices");
const get_doctor_attending_with_accountings_list_1 = require("../../types/doctor-attendings/get-doctor-attending-with-accountings-list");
const get_doctor_attending_with_invitations_list_1 = require("../../types/doctor-attendings/get-doctor-attending-with-invitations-list");
const remove_doctor_attending_office_1 = require("../../types/doctor-attendings/remove-doctor-attending-office");
const update_doctor_attending_1 = require("../../types/doctor-attendings/update-doctor-attending");
const success_response_schema_1 = require("../../types/global/success-response.schema");
const http_service_1 = require("../http.service");
class DoctorAttendingsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/doctor-attendings`);
    }
    getOffices(doctorAttendingId) {
        return this.get(`${encodeURIComponent(doctorAttendingId)}/offices`, { schema: get_doctor_attending_offices_1.getDoctorAttendingOfficesApiResponseSchema });
    }
    removeOffice(payload) {
        const path = `${encodeURIComponent(payload.doctorAttendingId)}/offices/${encodeURIComponent(payload.officeId)}`;
        return this.delete(path, {
            schema: remove_doctor_attending_office_1.removeDoctorAttendingOfficeApiResponseSchema,
        });
    }
    getDetails(id) {
        return this.getEntity(id, {
            schema: types_1.getDoctorAttendingApiResponseSchema,
        });
    }
    getList(payload) {
        const params = {
            ...payload,
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        return this.getEntityList('', {
            params,
            schema: get_doctor_attending_list_1.getDoctorAttendingsListApiResponseSchema,
        });
    }
    getListWithAccountings(payload) {
        const params = {
            ...payload,
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        return this.getEntityList('with-accountings', {
            params,
            schema: get_doctor_attending_with_accountings_list_1.getDoctorAttendingsWithAccountingsListApiResponseSchema,
        });
    }
    getListWithInvitations(payload) {
        const params = {
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        if (payload.officeId) {
            params.officeId = payload.officeId;
        }
        if (payload.search) {
            params.search = payload.search;
        }
        return this.getEntityList('with-invitations', {
            params,
            schema: get_doctor_attending_with_invitations_list_1.getDoctorAttendingsWithInvitationsListApiResponseSchema,
        });
    }
    create(payload) {
        return this.postEntity('', {
            body: payload,
            schema: create_doctor_attending_1.createDoctorAttendingApiResponseSchema,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    createByDoctor(payload) {
        return this.postEntity('by-doctor', {
            body: payload,
            schema: create_doctor_attending_by_doctor_1.createDoctorAttendingByDoctorApiResponseSchema,
        });
    }
    update(id, payload) {
        return this.putEntity(id, {
            body: payload,
            schema: update_doctor_attending_1.updateDoctorAttendingApiResponseSchema,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    deleteById(id) {
        return this.delete(id, {
            schema: delete_doctor_attending_1.deleteDoctorAttendingApiResponseSchema,
        });
    }
    generateAccounting(payload) {
        return this.postEntity('generate-accounting', {
            body: payload,
        });
    }
    activate(id) {
        const url = this.getApiUrlOf(`${id}/activate`);
        return this.fetch(url, {
            method: 'PATCH',
            schema: activate_doctor_attending_1.activateDoctorAttendingApiResponseSchema,
        }).then((apiResponse) => apiResponse.data);
    }
    /**
     * Deactivates the doctor behind this attending record (every office at
     * once): their history is kept, writes and login are frozen.
     */
    deactivate(id) {
        return this.post(`${encodeURIComponent(id)}/deactivate`, { schema: success_response_schema_1.successResponseSchema });
    }
    /** Reverts {@link deactivate}. */
    reactivate(id) {
        return this.post(`${encodeURIComponent(id)}/reactivate`, { schema: success_response_schema_1.successResponseSchema });
    }
    getMyLeave(payload) {
        return this.get('me/leave', {
            params: payload,
            schema: types_1.getAttendingLeaveApiResponseSchema,
        });
    }
    getLeaveById(id, payload) {
        return this.get(`${id}/leave`, {
            params: payload,
            schema: types_1.getAttendingLeaveApiResponseSchema,
        });
    }
    syncMyLeave(payload) {
        return this.put('me/leave', {
            body: payload,
            schema: types_1.syncAttendingLeaveApiResponseSchema,
        });
    }
    getContractList(id, payload) {
        const params = {
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        if (payload.officeId) {
            params.officeId = payload.officeId;
        }
        if (payload.search) {
            params.search = payload.search;
        }
        if (payload.period) {
            params.period = JSON.stringify(payload.period);
        }
        if (payload.signatureStatus && payload.signatureStatus !== 'all') {
            params.signatureStatus = payload.signatureStatus;
        }
        return this.getEntityList(`${id}/contracts/list`, {
            params,
            schema: types_1.getDoctorSubstituteContractsListApiResponseSchema,
        });
    }
}
exports.DoctorAttendingsHttpService = DoctorAttendingsHttpService;
